/** Preserve Fusion's existing first-subtag language convention. */
export function getLangFromLocale(locale: string) {
  return locale.split('-')[0]
}

/** Preserve Fusion's existing second-subtag country convention. */
export function getCountryFromLocale(locale: string) {
  return locale.split('-')[1]
}

/**
 * Admin presents language flags: the first subtag with the existing en → gb mapping.
 * This deliberately preserves that display convention, rather than selecting a region.
 */
export function getLocaleFlagCountryCode(locale: string): string {
  return getLangFromLocale(locale).replace('en', 'gb')
}
